var riot = require('riot');
module.exports = riot.tag2('view', '<div class="{viewClass}"> <div name="main" class="group main-container"></div> </div>', '', '', function(opts) {
        this.mixin(require('mixins/view').default);
});